import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Gtag } from 'angular-gtag';
import { ERROR_PAGE_MESSAGE_CUSTOMIZATIONS } from 'src/app/core/constants';
import { EnvService } from 'src/app/core/services';
import { SignOut } from 'src/app/core/store/user/user.actions';
import { CcsSentryError } from 'src/app/core/store/utils';
import { join } from 'src/app/core/utils/common';

@Component({
  selector: 'app-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss'],
})
export class PageErrorComponent implements OnInit {
  @Input() error?: CcsSentryError | CcsSentryError[] | null;

  ccsConfig = this.envService.ccs;
  sentryIds: string | null = null;
  errorMessages: string | null = null;
  title: string = 'Something went wrong';
  message: string = 'We could not load this page at this time. Please try again later.';

  constructor(private router: Router, private envService: EnvService, private store: Store, private gtag: Gtag) {}

  ngOnInit(): void {
    this.sentryIds = this.getSentryIds() || null;
    this.errorMessages = this.getSentryMessages() || null;
    this.updatePageTitleAndMessage();

    this.gtag.event('error_page_shown', {
      event_category: 'engagement',
      non_interaction: true,
      title: this.title,
      message: this.message,
      message_details: this.errorMessages,
    });
  }

  goToHome() {
    window.open('./', '_self');
  }

  getSentryMessages(): string | undefined {
    if (this.error instanceof CcsSentryError) {
      return this.error.uiMessage;
    } else if (this.error instanceof Array && this.error.length > 0) {
      return this.error.length > 1 ? join(this.error.map((e) => e.uiMessage || null)) : this.error[0].uiMessage;
    } else {
      return undefined;
    }
  }

  getSentryIds(): string | undefined {
    if (this.error instanceof CcsSentryError) {
      return this.error.sentryEventId;
    } else if (this.error instanceof Array && this.error.length > 0) {
      return this.error.length > 1
        ? join(
            this.error.map((e) => e.sentryEventId || null),
            ','
          )
        : this.error[0].sentryEventId;
    } else {
      return undefined;
    }
  }

  signOut() {
    console.log('401 Logging: Initiating User SignOut from error page...');
    this.store.dispatch(new SignOut());
  }

  updatePageTitleAndMessage() {
    for (const customization of ERROR_PAGE_MESSAGE_CUSTOMIZATIONS) {
      const regex = new RegExp(customization.regexString, 'i');

      if (this.errorMessages && regex.test(this.errorMessages)) {
        this.title = customization.errorTitle;
        this.message = customization.errorMessage;
        return;
      }
    }
  }
}
